var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8457 12.5747L13.8457 0.462301L51.8937 0.462302C52.8601 0.462302 53.6436 1.24575 53.6436 2.21219L53.6436 10.8248C53.6436 11.7913 52.8602 12.5747 51.8937 12.5747L13.8457 12.5747Z",
    fill: "#4EAE63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89675 12.5747C0.961118 12.5747 0.202637 11.8162 0.202637 10.8806L0.202637 2.1559C0.202637 1.22027 0.961118 0.46179 1.89675 0.46179L12.3156 0.46179L12.3156 12.5747L1.89675 12.5747Z",
    fill: "#F8F5EC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7075 5.02412V3.71408H21.107V5.02412H19.1597V9.46764H17.6549V5.02412H15.7075Z",
    fill: "#F8F5EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0156 9.46764V3.71408H23.5204V9.46764H22.0156Z",
    fill: "#F8F5EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4218 7.20163H30.9709V7.57339C30.6345 8.6887 29.4218 9.57386 27.8728 9.57386C26.0405 9.57386 24.695 8.3966 24.695 6.55546C24.695 4.71431 26.0405 3.5459 27.8728 3.5459C29.3422 3.5459 30.5725 4.28944 30.9709 5.54637V5.91814H29.413C29.1917 5.29852 28.634 4.94446 27.8728 4.94446C26.8814 4.94446 26.2264 5.54637 26.2264 6.55546C26.2264 7.57339 26.8814 8.17531 27.8728 8.17531C28.634 8.17531 29.2005 7.82124 29.4218 7.20163Z",
    fill: "#F8F5EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5366 4.04159L35.5096 6.05976V6.21909L37.8287 9.14013V9.46764H36.1558L34.3943 7.17507L33.6508 7.90976V9.46764H32.146V3.71408H33.6508V6.08632L35.9787 3.71408H37.5366V4.04159Z",
    fill: "#F8F5EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7156 9.46764V3.71408H43.4512V5.02412H40.2203V5.82077H43.2919V7.13081H40.2203V8.1576H43.4689V9.46764H38.7156Z",
    fill: "#F8F5EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2679 5.02412V3.71408H49.6674V5.02412H47.72V9.46764H46.2152V5.02412H44.2679Z",
    fill: "#F8F5EC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93569 7.55529C6.93569 8.90938 5.08304 8.89974 5.08304 7.55834V2.83301L3.08018 4.53032L3.07667 7.55834C3.06716 11.1855 8.93855 11.2012 8.94506 7.57461V6.21747L10.1072 7.09277V4.51101L8.09986 2.84875V5.42086L6.94071 4.47345L6.93569 7.55529Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketLogo);
export default __webpack_public_path__ + "static/media/ticket_logo.7622b143cbed1cd3d581dfc110bd6969.svg";
export { ForwardRef as ReactComponent };